import datetimeDecorator from 'src/decorators/datetime.decorator';
import { SalesOrderRecurrenceRule } from 'src/entities/SalesOrder.response.entity';

// 必要に応じて lodash の isEqual を使うか、独自の実装に置き換えてください
export function isEqual(obj1: object, obj2: object): boolean {
  if (!obj1 || !obj2) return false;
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  return keys1.every((key) => obj1[key] === obj2[key]);
}

export function formatRecurrence(rule: SalesOrderRecurrenceRule): string {
  if (!rule || rule.frequency === 'none') {
    return 'SPOT';
  }

  if (rule.frequency === 'daily') {
    if (rule.interval === 1 && rule.endCondition === 'none') {
      return '毎日';
    }
    let val = `${rule.interval} 日ごと`;
    if (rule.endCondition === 'by_count') {
      val = `${val}, ${rule.occurrences} 回`;
    } else if (rule.endCondition === 'by_date') {
      val = `${val}, ${datetimeDecorator.toYyyyMmDd(new Date(rule.endDate), '/')} まで`;
    }
    return val;
  }

  if (rule.frequency === 'weekly') {
    const defaultWeekdays = { mon: true, tue: true, wed: true, thu: true, fri: true, sat: false, sun: false };
    if (rule.interval === 1 && rule.endCondition === 'none' && isEqual(rule.dayOfWeeks, defaultWeekdays)) {
      return '平日 (月〜金)';
    }
    let val = `${rule.interval} 週ごと`;
    const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const WEEKDAY_LABELS = ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'];
    const wdays = WEEKDAYS.map((day, idx) => {
      if (rule.dayOfWeeks && rule.dayOfWeeks[day]) {
        return WEEKDAY_LABELS[idx];
      }
      return null;
    }).filter((label) => label !== null);
    val = `${val}, ${wdays.join(',')}`;
    if (rule.endCondition === 'by_count') {
      val = `${val}, ${rule.occurrences} 回`;
    } else if (rule.endCondition === 'by_date') {
      val = `${val}, ${datetimeDecorator.toYyyyMmDd(new Date(rule.endDate), '/')} まで`;
    }
    return val;
  }

  if (rule.frequency === 'monthly') {
    let val = `${rule.interval} ヶ月ごと`;
    if (rule.recurrenceType === 'day_of_month') {
      val = `${val}, ${rule.dayOfMonth} 日`;
    } else if (rule.recurrenceType === 'weekday_of_month') {
      const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      const WEEKDAY_LABELS = ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'];
      const dayKey = Object.keys(rule.dayOfWeeks).find((day) => rule.dayOfWeeks[day]);
      const idx = dayKey ? WEEKDAYS.indexOf(dayKey) : -1;
      if (idx !== -1) {
        val = `${val}, 第 ${rule.weekOfMonth} ${WEEKDAY_LABELS[idx]}`;
      }
    }
    if (rule.endCondition === 'by_count') {
      val = `${val}, ${rule.occurrences} 回`;
    } else if (rule.endCondition === 'by_date') {
      val = `${val}, ${datetimeDecorator.toYyyyMmDd(new Date(rule.endDate), '/')} まで`;
    }
    return val;
  }

  return '';
}
